// extracted by mini-css-extract-plugin
export var footerRoot = "style-module--footerRoot--iZqvl";
export var root = "style-module--root--ETGdQ";